import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PromptLogComponent } from './prompt-log/prompt-log.component';
import { AdvisorComponent } from './advisor/advisor.component';
import { AdvisorNewComponent } from './advisor_new/advisor-new.component';
import { PlaygroundComponent } from './playground/playground.component';
import { CollectionsComponent } from './collections/collections.component';
import { AdminComponent } from './admin/admin.component';
import { ReviewersComponent } from './reviewers/reviewers.component';
import { ReviewersDetailsComponent } from './reviewers/reviewers-details/reviewers.details.component';
import { SampleStylesComponent } from './sample-styles/sample-styles.component';
import { LibrariesComponent } from './Libraries/libraries.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'playground', component: PlaygroundComponent },
  { path: 'advisor', component: AdvisorNewComponent },
  { path: 'advisor-old', component: AdvisorComponent },
  { path: 'collections', component: CollectionsComponent },
  { path: 'prompt-log', component: PromptLogComponent },
  { path: 'admin', component: AdminComponent },
  { path: 'reviewers', component: ReviewersComponent },
  { path: 'reviewers/details/:reviewer_id', component: ReviewersDetailsComponent },
  { path: 'sample-styles', component: SampleStylesComponent },
  { path: 'library', component: LibrariesComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
